// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3O4sQ","imageUploader":"EGiftCard_imageUploader__1nGmW"};